import * as React from 'react';
import { Steps } from '../components/Steps';
import { Model, PageModel } from 'survey-core';
import { StepItem } from '../types/steps';

const buildSteps = (survey: Model) => {
  return survey.visiblePages.map((page: CustomPageModel, index) => ({
    active: survey.currentPageNo === index,
    title: page.title,
    wasShown: page.wasShown || survey.currentPageNo > index,
    hidden: page.skipInStepper
  }));
};

type CustomPageModel = PageModel & {
  skipInStepper?: boolean;
};

type Props = {
  survey: Model;
};
export const StepsContainer: React.FC<Props> = ({ survey }) => {
  const [steps, setSteps] = React.useState<StepItem[]>(buildSteps(survey));

  React.useEffect(() => {
    survey.onCurrentPageChanged.add(sender => {
      setSteps(buildSteps(sender));
    });
    survey.onPageVisibleChanged.add(sender => {
      setSteps(buildSteps(sender));
    });
  }, [survey]);

  const handleChangeStep = (step: number, activeStep: number) => {
    if (step === activeStep) return;
    if (step < activeStep) {
      survey.currentPageNo = step;
      return;
    }

    const prevPages = survey.visiblePages.filter((_, index) => index < step);
    const pagesValidation = survey.visiblePages.map(page => page.validate(page.isActive));
    const isValid = pagesValidation.filter((_, validationIndex) => validationIndex < step).every(valid => valid);
    if (!isValid) return;

    const isValidationAsync = prevPages.some(page =>
      page.questions.some(question =>
        question.validators.some(({ isAsync }) => {
          if (isAsync) {
            question.onCompletedAsyncValidators = (hasErrors: boolean) => {
              if (!hasErrors) {
                survey.currentPageNo = step;
              }
            };
          }
          return isAsync;
        })
      )
    );

    if (isValidationAsync) return;
    if (isValid) {
      survey.currentPageNo = step;
    }
  };

  return <Steps steps={steps} onChange={handleChangeStep} />;
};
